export const QuestionLine2Type = {
  text: "text",
  image: "image",
};
